import PropTypes from "prop-types";
import { IoIosArrowBack } from "react-icons/io";

const RestaurantView = (props) => {
    const { currentRestroData, handleCancel } = props;

    return (
        <section className="border-t border-[#D9D9D9] mt-5 pt-5 h-[90vh] overflow-y-scroll">
            <h3 className="md:text-4xl text-xl font-bold mb-2 poppins-medium">Vista Ristorante</h3>
            <div className="w-auto h-auto bg-[#FCFCFC] border-[1.5px] border-[#8B24332B] p-7 rounded-xl shadow-md font-sans">
                <h3 className="text-xl font-bold mb-2 poppins-regular">Informazioni</h3>
                <div className="border-b-[1px] border-[#e4d5d7] mb-6"></div>
                <div className="space-y-4">
                    <div className="flex md:flex-row flex-col gap-6">
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Nome:
                            </label>
                            <input
                                type="text"
                                placeholder="Dalary"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={currentRestroData?.username || "N/A"}
                                disabled
                            />
                        </div>
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Cognome:
                            </label>
                            <input
                                type="text"
                                placeholder="Sutton"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={currentRestroData?.surname || "N/A"}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="flex md:flex-row flex-col gap-6">
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Nome Ristorante:
                            </label>
                            <input
                                type="text"
                                placeholder="Asian Halal Food Mestre"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={currentRestroData?.restaurant_name || "N/A"}
                                disabled
                            />
                        </div>
                        <div className="flex flex-col md:w-[50%] w-fll space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Indirizzo Email:
                            </label>
                            <input
                                type="text"
                                placeholder="dalary@gmail.com"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={currentRestroData?.email || "N/A"}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="flex md:flex-row flex-col gap-6">
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Cellulare:
                            </label>
                            <input
                                type="text"
                                placeholder="012 345 6789"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={currentRestroData?.mobile_phone || "N/A"}
                                disabled
                            />
                        </div>
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Password:
                            </label>
                            <input
                                type="text"
                                placeholder="The Cookhouse"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={"*******"}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="flex md:flex-row flex-col gap-6">
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Descrizione Collaborazione:
                            </label>
                            <textarea
                                placeholder="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Itaque quaerat et hic suscipit voluptates blanditiis quos provident eius! A magnam quaerat cupiditate veritatis similique nam repudiandae mollitia atque. Labore, aliquam?"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] border-[#7777775c] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                rows={4}
                                value={currentRestroData?.collaboration_description?.replace(/<[^>]+>/g, '') || "N/A"}
                                disabled
                            />
                        </div>
                        <div className="flex flex-col md:w-[50%] w-full space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Ragione Sociale:
                            </label>
                            <input
                                type="text"
                                placeholder="The Cookhouse"
                                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                                value={currentRestroData?.company_name || "N/A"}
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-start mt-8">
                    <button
                        className="md:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 border-[1.5px] border-[#8B2433] text-[#8B2433] rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                        onClick={handleCancel}
                    >
                        <IoIosArrowBack size={"25px"} color="red" className="group-hover:invert" />
                        <span className="poppins-regular">Indietro</span>
                    </button>
                </div>
            </div>
        </section>
    );
};

RestaurantView.propTypes = {
    currentRestroData: PropTypes.shape({
        username: PropTypes.string,
        surname: PropTypes.string,
        restaurant_name: PropTypes.string,
        email: PropTypes.string,
        collaboration_description: PropTypes.string,
        mobile_phone: PropTypes.string,
        company_name: PropTypes.string,
    }),
    handleCancel: PropTypes.func.isRequired,
};

export default RestaurantView;

